import Card from "../../card/Card";
import React, {useState} from "react";
import {useActions} from "../../../hooks/useActions";
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {useSwipeable} from "react-swipeable";
import {SoundsService} from "../../../services/SoundsService";
import {sounds} from "../../../sounds/sound";


function CardSlide({card, amount, isDeck = false, addToDeck = false}) {
    const {isLoading, tutorial} = useTypedSelector(state => state.auth);
    const [showAnimation, setShowAnimation] = useState(false);

    const {addCard, removeCard} = useActions();

    const handlers = useSwipeable({
        onSwipedDown: () => playerSwipe(),
        onSwipedUp: () => playerSwipe()
    });

    const playerSwipe = () => {
        processPlayerAction();
    }
    const playerClick = () => {
        processPlayerAction()
    }

    const processPlayerAction = () => {
        if (isLoading) {
            return;
        }
        if(!isDeck && !addToDeck){
            return;
        }

        setShowAnimation(true);
        setTimeout(function () {
            setShowAnimation(false);
        }, 400);

        if (addToDeck) {

            SoundsService.playSound(sounds.deck_add_card());
            addCard(card.id);
            return;
        }
        if (isDeck) {
            SoundsService.playSound(sounds.deck_remove_card());
            removeCard(card.id);
            return;
        }
    }

    let animationLibClasses = '';
    if (showAnimation) {
        animationLibClasses = ' animate__animated';
        if (isDeck) {
            animationLibClasses += ' animate_remove_from_deck';
        } else {
            animationLibClasses += ' animate_add_to_deck';
        }
    }
    let additionalClasses = '';
    if(tutorial.isActive && tutorial.step === 'ClickAdd130' &&  card.id === 1050) {
        additionalClasses = ' defaultButtonAnimation_2_5'
    }

    return <div {...handlers} className={"card-slide-container" + animationLibClasses + additionalClasses} onClick={() => {
        playerClick();
    }}>

        {isDeck === true ?
            <div className={'deck-add-button-container'}>
                <div className='library-add-button deck-add-button'></div>
            </div>
            : null
        }

        <Card card={card} AmountNum={amount}/>
        {addToDeck === true ?
            <div className={'library-add-button-container'}>
                <div className={'library-add-button'}></div>
            </div>
            : null
        }
    </div>


}

export default CardSlide;